const dsPrefix = 'digital-sampling';
const dsRequestQuotePrefix = `${dsPrefix}-request-quote`;
const dsIncompleteProfileToastPrefix = `${dsPrefix}-incomplete-profile-toast`;
const dsPreviewFilesPrefix = `${dsPrefix}-preview-files`;
const dsFindDistributorsPrefix = `${dsPrefix}-find-distributors`;
const dsCatalogDownloadsPagePrefix = `${dsPrefix}-catalog-downloads-page`;
const dsUnitOfMeasurePrefix = `${dsPrefix}-unit-of-measure`;
const dsProductDetailsPagePrefix = `${dsPrefix}-product-details-page`;

export const definedTranslation = {
  requestQuote: {
    pricingAndQuoteLabel: {
      id: `${dsRequestQuotePrefix}-pricing-and-quote-label`,
      defaultMessage: 'Pricing & quote',
    },
    confirmProjectDetailsLabel: {
      id: `${dsRequestQuotePrefix}-confirm-project-details-label`,
      defaultMessage: 'Confirm your project details for a more accurate quote.',
    },
    learnMoreBtn: {
      id: `${dsRequestQuotePrefix}-learn-more-btn`,
      defaultMessage: 'Learn more',
    },
    submitRequestBtn: {
      id: `${dsRequestQuotePrefix}-submit-request-btn`,
      defaultMessage: 'Submit request',
    },
    nonZeroPurchaseQuantityError: {
      id: `${dsRequestQuotePrefix}-non-zero-purchase-quantity-error`,
      defaultMessage: 'Please enter a non-zero purchasing quantity',
    },
    assignRepresentativeError: {
      id: `${dsRequestQuotePrefix}-assign-representative-error`,
      defaultMessage: 'Please assign a representative',
    },
    noRepsError: {
      id: `${dsRequestQuotePrefix}-no-reps-error`,
      defaultMessage:
        'There are no reps assigned to this product so you cannot request a quote.',
    },
    chooseVariantLabel: {
      id: `${dsRequestQuotePrefix}-choose-variant-label`,
      defaultMessage: 'Choose variant',
    },
    intendedPurchasingQuantityLabel: {
      id: `${dsRequestQuotePrefix}-intended-purchasing-quantity-label`,
      defaultMessage: 'Intended purchasing quantity',
    },
    selectProjectLabel: {
      id: `${dsRequestQuotePrefix}-select-project-label`,
      defaultMessage: 'Select project',
    },
    // Request Quote Success
    successLabel: {
      id: `${dsRequestQuotePrefix}-success-primary-label`,
      defaultMessage: 'Your Quote has been submitted.',
    },
    successSubtextLabel: {
      id: `${dsRequestQuotePrefix}-success-subtext-label`,
      defaultMessage:
        'Thanks for submitting! Our brand partner will provide a quote as soon as possible, ensuring the most up-to-date and competitive pricing for your project. Thank you for your patience!',
    },
    goToInboxBtn: {
      id: `${dsRequestQuotePrefix}-go-to-inbox-btn`,
      defaultMessage: 'Go to Inbox',
    },
  },
  incompleteProfileToast: {
    title: {
      id: `${dsIncompleteProfileToastPrefix}-title`,
      defaultMessage:
        'Add an address to your address book to view digital sample info',
    },
  },
  previewFiles: {
    downloadFilesLabel: {
      id: `${dsPreviewFilesPrefix}-download-files-label`,
      defaultMessage: 'Download files',
    },
    fileSelectorPlaceholder: {
      id: `${dsPreviewFilesPrefix}-file-selector-placeholder`,
      defaultMessage: 'Select a file',
    },
    learnMoreBtn: {
      id: `${dsPreviewFilesPrefix}-learn-more-btn`,
      defaultMessage: 'Learn more',
    },
    unselectedFileLabel: {
      id: `${dsPreviewFilesPrefix}-unselected-file-label`,
      defaultMessage:
        'Choose a file, preview it here, and download your selected files',
    },
    downloadFileBtn: {
      id: `${dsPreviewFilesPrefix}-download-file-btn`,
      defaultMessage: 'Download file',
    },
    downloadFilesBtn: {
      id: `${dsPreviewFilesPrefix}-download-files-btn`,
      defaultMessage: 'Download files',
    },
    cancelBtn: {
      id: `${dsPreviewFilesPrefix}-cancel-btn`,
      defaultMessage: 'Cancel',
    },
    selectFilesBtn: {
      id: `${dsPreviewFilesPrefix}-select-files-btn`,
      defaultMessage: 'Select files',
    },
    noFileSelected: {
      id: `${dsPreviewFilesPrefix}-no-file-selected`,
      defaultMessage: 'No file selected',
    },
    noPreviewAvailable: {
      id: `${dsPreviewFilesPrefix}-no-preview-available`,
      defaultMessage:
        'The file <b>{fileName}</b> cannot be previewed due to its format',
    },
    changeProject: {
      id: `${dsPreviewFilesPrefix}-change-project`,
      defaultMessage: 'Change project',
    },
    createANewProject: {
      id: `${dsPreviewFilesPrefix}-create-a-new-project`,
      defaultMessage: 'Create a new project',
    },
  },
  findDistributors: {
    distributorsLabel: {
      id: `${dsFindDistributorsPrefix}-distributors-label`,
      defaultMessage: 'Distributors',
    },
    searchPlaceholder: {
      id: `${dsFindDistributorsPrefix}-search-placeholder`,
      defaultMessage: 'Search',
    },
  },
  catalogDownloadsPage: {
    digitalCatalogDownloadsLabel: {
      id: `${dsCatalogDownloadsPagePrefix}-digital-catalog-downloads-label`,
      defaultMessage: 'Digital Catalog Downloads',
    },
    newestLabel: {
      id: `${dsCatalogDownloadsPagePrefix}-newest-label`,
      defaultMessage: 'Newest',
    },
    oldestLabel: {
      id: `${dsCatalogDownloadsPagePrefix}-oldest-label`,
      defaultMessage: 'Oldest',
    },
    filtersLabel: {
      id: `${dsCatalogDownloadsPagePrefix}-filters-label`,
      defaultMessage: 'Filters',
    },
    allBrandsLabel: {
      id: `${dsCatalogDownloadsPagePrefix}-all-brands-label`,
      defaultMessage: 'All Brands',
    },
    allCategoriesLabel: {
      id: `${dsCatalogDownloadsPagePrefix}-all-categories-label`,
      defaultMessage: 'All Categories',
    },
    sortByPlaceholder: {
      id: `${dsCatalogDownloadsPagePrefix}-sort-by-placeholder`,
      defaultMessage: 'Sort by',
    },
    projectLabel: {
      id: `${dsCatalogDownloadsPagePrefix}-project-label`,
      defaultMessage: 'Project',
    },
    previewAndDownloadFilesBtn: {
      id: `${dsCatalogDownloadsPagePrefix}-preview-and-download-files-btn`,
      defaultMessage: 'Preview & download files',
    },
    previousBtn: {
      id: `${dsCatalogDownloadsPagePrefix}-previous-btn`,
      defaultMessage: 'Previous',
    },
    nextBtn: {
      id: `${dsCatalogDownloadsPagePrefix}-next-btn`,
      defaultMessage: 'Next',
    },
    pageLabel: {
      id: `${dsCatalogDownloadsPagePrefix}-page-label`,
      defaultMessage: 'Page',
    },
    noDigitalDownloadsLabel: {
      id: `${dsCatalogDownloadsPagePrefix}-no-digital-downloads-label`,
      defaultMessage: 'No digital downloads yet',
    },
    noDigitalDownloadsSubtextLabel: {
      id: `${dsCatalogDownloadsPagePrefix}-no-digital-downloads-subtext-label`,
      defaultMessage:
        "Products and files you've downloaded will be saved here for easy access",
    },
    exploreDigitalCatalogBtn: {
      id: `${dsCatalogDownloadsPagePrefix}-explore-digital-catalog-btn`,
      defaultMessage: 'Explore digital catalog',
    },
    clearAllBtn: {
      id: `${dsCatalogDownloadsPagePrefix}-clear-all-btn`,
      defaultMessage: 'Clear all',
    },
  },
  unitOfMeasure: {
    unitsLabel: {
      id: `${dsUnitOfMeasurePrefix}-units-label`,
      defaultMessage: 'units',
    },
    linearFtLabel: {
      id: `${dsUnitOfMeasurePrefix}-linear-ft-label`,
      defaultMessage: 'linear ft',
    },
    linearYardsLabel: {
      id: `${dsUnitOfMeasurePrefix}-linear-yards-label`,
      defaultMessage: 'linear yards',
    },
    sqFtLabel: {
      id: `${dsUnitOfMeasurePrefix}-sq-ft-label`,
      defaultMessage: 'sq ft',
    },
    gallonsLabel: {
      id: `${dsUnitOfMeasurePrefix}-gallons-label`,
      defaultMessage: 'gallons',
    },
    linearMetersLabel: {
      id: `${dsUnitOfMeasurePrefix}-linear-meters-label`,
      defaultMessage: 'm',
    },
    sqMetersLabel: {
      id: `${dsUnitOfMeasurePrefix}-sq-meters-label`,
      defaultMessage: 'sq meters',
    },
  },
  productDetailsPage: {
    pricingAndQuoteLabel: {
      id: `${dsProductDetailsPagePrefix}-pricing-and-quote-label`,
      defaultMessage: 'Pricing & quote',
    },
    previewAndDownloadFilesBtn: {
      id: `${dsProductDetailsPagePrefix}-preview-and-download-files-btn`,
      defaultMessage: 'Preview & download files',
    },
    downloadLabel: {
      id: `${dsProductDetailsPagePrefix}-download-label`,
      defaultMessage: 'Download',
    },
  },
};
